"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = once;
function once(fn) {
  var done;
  return function () {
    if (!done) {
      fn();
      done = 1;
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJvbmNlIiwiZm4iLCJkb25lIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL29uY2UudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gb25jZShmbjogKCkgPT4gdm9pZCk6ICgpID0+IHZvaWQge1xuICBsZXQgZG9uZTtcblxuICByZXR1cm4gKCkgPT4ge1xuICAgIGlmICghZG9uZSkge1xuICAgICAgZm4oKTtcbiAgICAgIGRvbmUgPSAxO1xuICAgIH1cbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQWUsU0FBU0EsSUFBSUEsQ0FBQ0MsRUFBYyxFQUFjO0VBQ3ZELElBQUlDLElBQUk7RUFFUixPQUFPLFlBQU07SUFDWCxJQUFJLENBQUNBLElBQUksRUFBRTtNQUNURCxFQUFFLENBQUMsQ0FBQztNQUNKQyxJQUFJLEdBQUcsQ0FBQztJQUNWO0VBQ0YsQ0FBQztBQUNIIn0=